import {useTimeUnitTranslation} from '@aboutyou/i18n';
import {
  CountdownUnitProps,
  FONT_SIZES,
  FONT_WEIGHTS,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const CouponExpiryDateCountdownUnitComponent: React.FC<
  CountdownUnitProps & {className?: string}
> = ({value, unit, className}) => {
  const timeFormat = useTimeUnitTranslation('shorter');

  if (unit === 'days' && Number(value) === 0) {
    return null;
  }

  if (unit === 'hours' && Number(value) === 0) {
    return null;
  }

  if (unit === 'seconds') {
    return null;
  }

  return (
    <Unit className={className}>
      <span>{value}</span>
      <span>{timeFormat[unit]}</span>
    </Unit>
  );
};

const Unit = styled.div`
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: ${FONT_SIZES.px20};
  text-transform: uppercase;
`;
